import React from 'react';
import CameraFrame from '../components/ui/CameraFrame';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCpu, FiHardDrive, FiActivity } = FiIcons;

const Settings = () => {
  return (
    <div className="max-w-4xl mx-auto space-y-8 animate-in fade-in duration-500">
      <header className="mb-10 border-b border-[#222] pb-6">
        <h2 className="font-mono text-3xl text-white tracking-widest uppercase flex items-center gap-3">
          <SafeIcon icon={FiCpu} className="text-pink-500" />
          System Settings
        </h2>
        <p className="font-mono text-sm text-[#666] mt-2">Configure environment variables and diagnostics.</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <CameraFrame className="p-6">
          <h3 className="font-mono text-white text-lg mb-4 flex items-center gap-2 border-b border-[#333] pb-2">
            <SafeIcon icon={FiHardDrive} className="text-[#888]" />
            Local Storage
          </h3>
          <div className="space-y-4 font-mono text-sm">
            <div className="flex justify-between">
              <span className="text-[#666]">Cache Size</span>
              <span className="text-white">245 MB</span>
            </div>
            <div className="flex justify-between">
              <span className="text-[#666]">Offline Sync</span>
              <span className="text-pink-500">Enabled</span>
            </div>
            <button className="w-full py-2 mt-4 border border-[#333] text-[#888] hover:border-pink-500 hover:text-pink-500 transition-colors uppercase tracking-widest text-xs">
              Purge Cache
            </button>
          </div>
        </CameraFrame>

        <CameraFrame className="p-6">
          <h3 className="font-mono text-white text-lg mb-4 flex items-center gap-2 border-b border-[#333] pb-2">
            <SafeIcon icon={FiActivity} className="text-[#888]" />
            Diagnostics
          </h3>
          <div className="space-y-4 font-mono text-sm">
            <div className="flex justify-between">
              <span className="text-[#666]">Server Status</span>
              <span className="text-green-500 flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span> Online
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-[#666]">Version</span>
              <span className="text-white">v2.4.1-beta</span>
            </div>
            <div className="flex justify-between">
              <span className="text-[#666]">Latency</span>
              <span className="text-white">12ms</span>
            </div>
          </div>
        </CameraFrame>
      </div>

      <div className="mt-12 pt-8 border-t border-[#222] text-center">
        <p className="font-mono text-xs text-[#555] tracking-widest uppercase">
          Core Engine Output
        </p>
        {/* MANDATORY CREDIT */}
        <p className="font-mono text-sm text-[#888] mt-2 tracking-wider">
          Made by LingLink AI and DigLab AI
        </p>
      </div>
    </div>
  );
};

export default Settings;